export default __webpack_public_path__ + "static/media/Thumb-7.8fe30687.png";